export const FREIGHT_SERVICE_TYPE_NAME = 'FREIGHT'
export const DETAILED_VIEW_BUTTON_TITLE = 'DETAILED VIEW'
export const SUMMARY_VIEW_BUTTON_TITLE = 'SUMMARY VIEW'
export const MIN_QTY = 1
export const MIN_PRICE = 0.01
export const WIP_LOCATION = 'WIP Location'
export const IN_HOUSE_PAINT = 'In-House Paint'
export const WO_DUE_DATE_NOTIFICATION = 'WO Due Date is less than 3 days from the Ship Date. Please discuss with your Plant Manager if your WO Due Date is feasible'
export const STANDARD_PRICE_CHANGING_POPUP = 'The price entered is different from the standard price table. Click "Save" if you are going to use this price in future'
export const PICK_UP_POPUP = 'Please verify Pick-Up Location'
export const NO_DATA_TEXT = 'To add new row please press the "Enter"'
export const CBHR_URL = 'https://cbhr.antalex.ca/'
export const HR_URL = CBHR_URL + 'hr/'
export const HR_API_URL = CBHR_URL + 'api/v1/hr/'
export const CBCRM_URL = 'https://cbcrm.antalex.ca/'



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/consts.js